import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { BaseInput, Label as BaseLabel } from '../../../shared/FormStyles';

export const Title = styled.h3`
  color: ${themeGet('colors.black.100')};
  margin: 0;
  font-size: 18px;
  font-weight: 500;
`;

export const Label = styled(BaseLabel)`
  margin-bottom: 8px;
`;

export const Input = styled(BaseInput)`
  margin: 0 0 16px 0 !important;
  border: 1px solid ${themeGet('colors.black.20')} !important;
`;

export const EmailInput = styled(BaseInput)`
  border: none !important;
  border-radius: 8px 0 0 8px !important;
  flex: 1 0;
`;

export const EmailSuffix = styled.div`
  padding: 13px 16px;
  font-weight: 500;
  font-size: 14px;
  border-width: 0;
  border-radius: 0 8px 8px 0;
  color: ${themeGet('colors.black.100')};
  background-color: ${themeGet('colors.black.10')};
`;

export const UrlInput = styled(EmailInput)`
  border-radius: 8px !important;
`;

export const UrlPrefix = styled(EmailSuffix)`
  border-radius: 8px 0 0 8px;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  position: relative;
`;

export const Information = styled.i`
  margin: 0 4px;
`;

export const TopBar = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 24px;
`;

export const ButtonGroup = styled.div`
  display: flex;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  margin-left: auto;
`;

export const ModalButtonGroup = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

export const SmallLabel = styled.span`
  color: ${themeGet('colors.primary.100')};
  font-size: 12px;
  cursor: pointer;
  font-weight: 600;
`;

export const TextAreaInput = styled.textarea`
  font-weight: 500;
  font-size: 14px;
  margin: 0;
  border-radius: 8px;
  padding: 11px 16px;
  color: ${themeGet('colors.black.100')};
  border: 1px solid ${themeGet('colors.black.20')};

  ::placeholder {
    color: ${themeGet('colors.black.40')};
  }
`;

export const ToggleSection = styled.div`
  display: flex;
  width: 100%;
  margin: 0 0 8px;

  &:nth-last-child(2) {
    margin: 0 0 24px;
  }
`;

export const ToggleLabel = styled.span`
  font-size: 14px;
  color: ${themeGet('colors.black.100')} !important;
  margin: 0 10px 0 20px;
`;

export const ToggleDiv = styled.div`
  margin-left: auto;
`;

export const Box = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 0 0 16px;
  align-items: center;
`;

export const ErrorMessage = styled.span`
  color: ${themeGet('colors.error.default')};
  position: absolute;
  right: 0;
  top: calc(100% + 6px);
  font-size: 12px;
`;

export const UrlWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-radius: 8px;
  border: solid 1px;
  align-items: center;
  border-color: ${({ error }) =>
    error ? themeGet('colors.error.default') : themeGet('colors.black.20')};
`;
